import React, { type ReactNode } from "react";
import { ButtonNew } from "components/buttonNew";

type TEmailBuilderPageStatusProps = {
  title: string;
  description: ReactNode;
  detail?: string | null;
  primaryActionLabel: string;
  onPrimaryAction: () => void;
};

export function EmailBuilderPageStatus(props: TEmailBuilderPageStatusProps) {
  const { title, description, detail, primaryActionLabel, onPrimaryAction } = props;

  return (
    <div className="email-builder-page email-builder-page--status">
      <div className="email-builder-page-status">
        <h1 className="email-builder-page-status__title">{title}</h1>
        <div className="email-builder-page-status__description">{description}</div>
        {detail != null && detail.length > 0 ? (
          <p className="email-builder-page-status__detail">{detail}</p>
        ) : null}
        <div className="email-builder-page-status__actions">
          <ButtonNew type="primary" onClick={onPrimaryAction}>
            {primaryActionLabel}
          </ButtonNew>
        </div>
      </div>
    </div>
  );
}
